(function () {
  'use strict';

  /*
   * WHOLEDAY — FIRMHOUSE CART COUNT ONLY
   *
   * This file ONLY controls the Firmhouse quantity
   * shown on the existing Horizon header cart icon.
   *
   * It does NOT change:
   * - Firmhouse cart behavior
   * - Free spoon
   * - Upsells
   * - Delivery
   * - Checkout
   * - Buy box
   * - Cart opening
   */

  var BADGE_CLASS = 'wholeday-firmhouse-cart-count';
  var STYLE_ID = 'wholeday-firmhouse-cart-count-style';

  function getHeaderCartButton() {
    var button = document.querySelector(
      '[data-testid="cart-drawer-trigger"]'
    );

    if (button) {
      return button;
    }

    return document.querySelector(
      'header button[aria-controls="cart-drawer"],' +
      ' header button[aria-label*="cart" i],' +
      ' header button[aria-label*="winkelwagen" i]'
    );
  }

  function getFirmhouseQuantity(cart) {
    if (
      !cart ||
      !Array.isArray(cart.orderedProducts)
    ) {
      return 0;
    }

    return cart.orderedProducts.reduce(function (total, item) {
      if (!item) {
        return total;
      }

      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function addBadgeStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');

    style.id = STYLE_ID;

    style.textContent = `
      .${BADGE_CLASS} {
        position: absolute !important;

        /*
         * Position the green circle over the
         * bottom-right of the shopping bag icon.
         */
        right: -0px !important;
        bottom: -0px !important;

        width: 18px !important;
        height: 18px !important;
        min-width: 18px !important;
        max-width: 18px !important;

        padding: 0 !important;
        margin: 0 !important;

        box-sizing: border-box !important;

        display: none;
        align-items: center !important;
        justify-content: center !important;

        border-radius: 50% !important;
        -webkit-border-radius: 50% !important;

        background: #a2f56f !important;
        color: #000 !important;

        font-family: var(
          --font-body--family,
          "DM Sans",
          sans-serif
        ) !important;

        font-size: 11px !important;
        font-weight: 700 !important;
        line-height: 18px !important;

        text-align: center !important;

        pointer-events: none !important;

        z-index: 9999 !important;

        white-space: nowrap !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getOrCreateBadge(button) {
    var badge = button.querySelector(
      '.' + BADGE_CLASS
    );

    if (badge) {
      return badge;
    }

    /*
     * Make the cart button a positioning container.
     * This does not change the button's functionality.
     */
    var currentPosition =
      window.getComputedStyle(button).position;

    if (
      currentPosition === 'static' ||
      !currentPosition
    ) {
      button.style.position = 'relative';
    }

    badge = document.createElement('span');

    badge.className = BADGE_CLASS;

    badge.setAttribute(
      'aria-hidden',
      'true'
    );

    button.appendChild(badge);

    return badge;
  }

  function updateBadge(quantity) {
    var button = getHeaderCartButton();

    if (!button) {
      return;
    }

    var badge = getOrCreateBadge(button);

    /*
     * Hide the badge when the Firmhouse cart is empty.
     */
    if (quantity <= 0) {
      badge.style.display = 'none';
      return;
    }

    badge.textContent = String(quantity);
    badge.style.display = 'flex';
  }

  function readFirmhouseCart() {
    if (
      !window.Firmhouse ||
      typeof window.Firmhouse.currentCart !== 'function'
    ) {
      return;
    }

    window.Firmhouse.currentCart()
      .then(function (cart) {
        var quantity = getFirmhouseQuantity(cart);

        updateBadge(quantity);
      })
      .catch(function (error) {
        console.warn(
          '[Firmhouse Cart Count] Could not read Firmhouse cart',
          error
        );
      });
  }

  function start() {
    addBadgeStyles();

    /*
     * Initial cart quantity.
     */
    readFirmhouseCart();

    /*
     * Firmhouse changes independently from
     * Shopify's cart, so keep the badge synchronized.
     */
    window.setInterval(function () {
      readFirmhouseCart();
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }

})();